import { render } from "./SignUpWelcome.vue?vue&type=template&id=2cd4992c&scoped=true&ts=true"
import script from "./SignUpWelcome.vue?vue&type=script&lang=ts"
export * from "./SignUpWelcome.vue?vue&type=script&lang=ts"

import "./SignUpWelcome.vue?vue&type=style&index=0&id=2cd4992c&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd4992c"]])

export default __exports__